import React, { useEffect, useState } from 'react';
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function CuadroReacciones(props) {
    const {item,regional}=props;
    const [reaccionNoticia,setReaccionNoticia]=useState({});
    const [actualizaR,setActualizaR]=useState(0);
    const reaccionar = (item, tipo) => {
        var info = JSON.parse(localStorage.getItem('info'))
        fetch(`${server}/redSocial/reaccionarNoticia`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regional,
                tipo,
                idEmpleado: info.ID_EMPLEADO,
                idNoticia: item.ID_NOTICIA
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.ok) {
                    setReaccionNoticia(data.ok);
                    setActualizaR(actualizaR+1);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    useEffect(()=>{
        setReaccionNoticia(item);
    },[])
    return (
        <div className='btn-group'>
            <a className={`btn btn-dark btn-sm m-0 p-0 mx-2 text-center ${reaccionNoticia.REACCION ==='L' ? 'text-warning' : 'text-light'}`} onClick={() => reaccionar(item, 'L')}>
                <div className='container-fluid'>
                    <i className="fa-regular fa-thumbs-up fa-xl"></i>
                    <span className="badge bg-secondary">{reaccionNoticia.GUSTA}</span>
                </div>
            </a>
            <a className={`btn btn-sm m-0 p-0  mx-2 text-center ${reaccionNoticia.REACCION ==='F' ? 'text-warning' : 'text-light'}`} onClick={() => reaccionar(item, 'F')}>
                <div className='container-fluid'>
                    <i className="fa-regular fa-thumbs-down fa-xl"></i>
                    <span className="badge bg-secondary">{reaccionNoticia.NOGUSTA}</span>
                </div>
            </a>
            <a className={`btn btn-sm m-0 p-0  mx-2 text-center ${reaccionNoticia.REACCION ==='E' ? 'text-warning' : 'text-light'}`} onClick={() => reaccionar(item, 'E')}>
                <div className='container-fluid'>
                    <i className="fa-solid fa-heart fa-xl"></i>
                    <span className="badge bg-secondary">{reaccionNoticia.ENCANTA}</span>
                </div>
            </a>
            <a className={`btn btn-sm m-0 p-0 mx-2 ${reaccionNoticia.SYNC !== null ? 'text-warning' : 'text-light'}`} onClick={() => reaccionar(item, 'M')}>
                <i className="fa-solid fa-star fa-xl"></i>
            </a>
        </div>
    )
}

export default CuadroReacciones
